import { Component, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import CheckboxButtonComponent from "../checkbox-button/checkbox-button.component.vue";
import SingleCheckboxButton from "@/components/single-checkbox-button/single-checkbox-button.component.vue";
import InputOtherComponent from "../input-other/input-other.component.vue";
import SignatureSubmissionComponent from "../signature-submission/signature-submission.component.vue";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { CERTIFICATION_APPLICATION_FORM_QUERY } from "@/graphql/certification-application-form-query";
import EligibilityCriteriaComponent from "../eligibility-criteria/eligibility-criteria.component.vue";
import {
  CertificationForm,
  FormFieldContents,
  FormNavbar,
  formtInputData,
} from "@/models/certification-form/certification-form.interface";
import CertificationPreviewForm from "../certification-preview-form/certification-preview-form.component.vue";
import { certificationFormApi } from "@/providers/apis/certification-form";
import { utils } from "@/utils/utils";
import moment from "moment";
import ScopeOfActivity from "../scope-of-activity/scope-of-activity-component.vue";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import FormInputDatepickerComponent from "../form-input-datepicker/form-input-datepicker.component.vue";

@Component({
  name: "certification-form",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-checkbox": CheckboxButtonComponent,
    "b-form-single-checkbox": SingleCheckboxButton,
    "b-form-checkbox-input": InputOtherComponent,
    "b-form-signature-submission": SignatureSubmissionComponent,
    "certification-preview-form": CertificationPreviewForm,
    "code-of-ethics-and-scope-of-activity": ScopeOfActivity,
    "b-form-input-datepicker": FormInputDatepickerComponent,
    AppLoaderComponent,
    EligibilityCriteriaComponent,
    ErrorPopupComponent,
  },
})
export default class CertificationApplicationForm extends Vue {
  public formPagination = 0;
  public formName = "certificationPartTwoApplicationForm";
  public applicationData: Array<CertificationForm> = [];
  public applicationNavData: FormNavbar[] = [];
  public formData: FormFieldContents[] = [];
  public isNavLoad = false;
  public isScroll = false;
  public isValid = false;
  public formDataResult: any;
  public formApplicationId = "";
  public currentForm: any;
  public signatureInvalid = false;
  public saveDataDraft = false;
  public referenceEmailDuplicateIndexs: number[] = [];
  public supervisorEmailDuplicateIndexs: number[] = [];
  public payLoadData: any = {
    fillStatus: "DRAFT",
    id: "",
    isEligibility: false,
    certificationPartTwoApplicationForm: {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      addressLine1: "",
      addressLine2: "",
      state: "",
      city: "",
      zip: "",
    },
    certificationDetails: {
      successfullyCompleted: "",
      substanceAbuse: "",
      peerSupportServices: "",
      supervisionRequirements: "",
      handbook: {
        supervisionRequirements: {
          issupervisionRequirementsChecked: [],
          supervisionRequirementsFirstName: "",
          supervisionRequirementsLastName: "",
        },
        codeOfEthics: {
          isCodeofEthicsChecked: [],
          codeofEthicsFirstName: "",
          codeofEthicsLastName: "",
        },
        scopeOfActivity: {
          isScopeofActivityChecked: [],
          scopeofActivityFirstName: "",
          scopeofActivityLastName: "",
        },
      },
    },
    certificationPartTwoSupervisorInformation: [
      {
        supervisorAgencyOrOrganization: "",
        supervisorPositionOrTitle: "",
        stillEmployed: "",
        startDate: "",
        endDate: "",
        supervisorFirstName: "",
        supervisorLastName: "",
        supervisorCredentials: "",
        supervisorPhone: "",
        supervisorEmail: "",
        descripePeerSupportResponsibity: "",
      },
    ],
    certificationPartTwoRefererenceInformation: [
      {
        firstName: "",
        lastName: "",
        referencePhoneNumber: "",
        referenceEmailAddress: "",
        reference: 1,
      },
      {
        firstName: "",
        lastName: "",
        referencePhoneNumber: "",
        referenceEmailAddress: "",
        reference: 2,
      },
      {
        firstName: "",
        lastName: "",
        referencePhoneNumber: "",
        referenceEmailAddress: "",
        reference: 3,
      },
    ],
    certificationSignature: {
      isSignature: "",
      submissionDate: moment().format("MM-DD-YYYY"),
    },
  };
  public formTitle = {
    main_title: "",
    application_name: "",
  };
  public isLoading = false;
  public isEligibility = false;
  public certificateApplicantId = "";
  public userDetails: any;
  public isReviewerUser: any;
  public applicantFullDetials: any;
  public formCompletedIndex: number[] = [];
  public isEdit = false;
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    avoidNumbersAndSpecialChar: this.avoidNumbersAndSpecialCharacter,
    telCharacter: this.telCharacterValidate,
    onlyAlphabets: this.onlyAlphabets,
  };
  public checkValidForm = false;
  public mainId = "app";
  public currentYearMonth = "";
  public currentMonth = "";
  public hideDiv: string[] = ["endDate"];
  public checkField: string[] = ["stillEmployed"];
  public endDateShowIdx: number[] = [];
  public checkSOAValid = false;
  public validSOA = true;
  public errorMessage = "";
  public supervisorFormFields: formtInputData[] = [];
  public tempSupervisorFormFields: formtInputData = {} as formtInputData;
  public supervisorUIUpdate = false;
  public supervisorEndDateShowIdx: number[] = [];
  public supervisorStartDateShowIdx: number[] = [];

  constructor() {
    super();
  }

  public async created() {
    const currentMonth = `${moment().month() + 1}`;
    this.currentYearMonth = `${moment().year()}-${
      currentMonth.length == 1 ? "0" : ""
    }${currentMonth}`;
    this.userDetails = utils.getUserDetails();
    const token = localStorage.getItem("access_token");
    if (this.userDetails) {
      const userRolesData = this.userDetails.roles;
      this.isReviewerUser =
        userRolesData && userRolesData.indexOf("REVIEWER") !== -1;
    } else {
      this.isReviewerUser = false;
    }
    let payloadStorage: any = localStorage.getItem("certificationFormPayload");
    if (payloadStorage) {
      payloadStorage = JSON.parse(payloadStorage);
      this.payLoadData = { ...payloadStorage };
      if (this.payLoadData.isEligibility) {
        this.isEligibility = true;
        this.formPagination = 1;
      }
    }
    const formFilledIndex: any = localStorage.getItem(
      "certificationFormFilledIndex"
    );
    if (formFilledIndex) {
      formFilledIndex.split(",").forEach((data: string) => {
        this.formCompletedIndex.push(Number(data));
      });
    } else {
      if (!this.formCompletedIndex.includes(this.formPagination)) {
        this.formCompletedIndex.push(this.formPagination);
      }
    }

    if (!this.isReviewerUser && token && !payloadStorage) {
      const userDetailsEmail = this.userDetails.email;
      certificationFormApi
        .getCertificateDetials(userDetailsEmail)
        .then((result: any) => {
          this.applicantFullDetials = result.data.data;
          this.payLoadData.certificationPartTwoApplicationForm.firstName =
            this.applicantFullDetials.certificationPartOneBasicDetails.firstName;
          this.payLoadData.certificationPartTwoApplicationForm.lastName =
            this.applicantFullDetials.certificationPartOneBasicDetails.lastName;
          this.payLoadData.certificationPartTwoApplicationForm.phone =
            this.applicantFullDetials.certificationPartOneBasicDetails.primaryPhone;
          this.payLoadData.certificationPartTwoApplicationForm.email =
            this.applicantFullDetials.certificationPartOneBasicDetails.email;
          this.payLoadData.certificationPartTwoApplicationForm.addressLine1 =
            this.applicantFullDetials.certificationPartOneBasicDetails.addressLine1;
          this.payLoadData.certificationPartTwoApplicationForm.addressLine2 =
            this.applicantFullDetials.certificationPartOneBasicDetails.addressLine2;
          this.payLoadData.certificationPartTwoApplicationForm.state =
            this.applicantFullDetials.certificationPartOneBasicDetails.state;
          this.payLoadData.certificationPartTwoApplicationForm.city =
            this.applicantFullDetials.certificationPartOneBasicDetails.city;
          this.payLoadData.certificationPartTwoApplicationForm.zip =
            this.applicantFullDetials.certificationPartOneBasicDetails.zip;
        })
        .catch((error) => {
          this.errorMessage = utils.errorMessage(error);
          this.isLoading = false;
          this.errorMessage = utils.errorMessage(error);
        });
    } else {
      if (!payloadStorage) {
        this.$router.push({
          name: "login-page",
          query: { application: "certification-form" },
        });
      }
    }

    if (this.formPagination === 1) {
      this.isNavLoad = true;
    }
    this.$apollo
      .query({
        query: gql`query ${CERTIFICATION_APPLICATION_FORM_QUERY}`,
      })
      .then((result) => {
        this.applicationData = result.data.certificationApplicationForms.data;
        this.formTitle = {
          main_title: this.applicationData[0].attributes.main_title,
          application_name: this.applicationData[0].attributes.application_name,
        };
        this.applicationNavData = this.applicationData[0].attributes.navbar;
        this.formData = this.applicationData[0].attributes.form_fields;
        this.tempSupervisorFormFields = JSON.parse(
          JSON.stringify(
            this.applicationData[0].attributes.form_fields[2].fields
              .formInputs[0]
          )
        );
        if (this.payLoadData.certificationPartTwoSupervisorInformation.length) {
          const addSupervisorForm =
            this.payLoadData.certificationPartTwoSupervisorInformation.length;
          for (let index = 0; index < addSupervisorForm; index++) {
            this.supervisorFormFields.push(this.tempSupervisorFormFields);
          }
        }
        for (let index = 0; index < this.checkField.length; index++) {
          for (
            let i = 0;
            i <
            this.payLoadData.certificationPartTwoSupervisorInformation.length;
            i++
          ) {
            if (
              this.payLoadData.certificationPartTwoSupervisorInformation[i]
                .stillEmployed
            ) {
              this.fieldUpdate(this.checkField[index], true, i);
            }
          }
        }
        // Arm autosave only now: everything above is the form loading itself,
        // not the applicant filling it in.
        this.$nextTick(() => {
          this.startDraftAutoSave();
        });
      });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
  }

  public formEdit(slug: any) {
    this.isEdit = true;
    this.formName = slug;
    if (slug == "certificationPartTwoApplicationForm") {
      this.formPagination = 1;
    } else if (slug == "certificationDetails") {
      this.formPagination = 2;
    } else if (slug == "certificationPartTwoSupervisorInformation") {
      this.formPagination = 3;
    } else if (slug == "certificationPartTwoRefererenceInformation") {
      this.formPagination = 4;
    } else if (slug == "certificationSignature") {
      this.payLoadData.certificationSignature.isSignature = "";
      localStorage.setItem(
        "certificationFormPayload",
        JSON.stringify(this.payLoadData)
      );
      this.formPagination = 5;
    }
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  public scopeOfActivityValidation(event: boolean) {
    this.validSOA = event;
  }

  public nextButton() {
    this.checkValidForm = true;
    this.checkSOAValid = !this.checkSOAValid;
    /*
     * formPagination is 1-based over the steps - the template renders
     * formData[index] when formPagination === index + 1 - with 0 reserved for
     * the eligibility screen. So the last form step, the signature, is
     * length - 1, and the preview it leads to is length.
     *
     * This fired a step early, at length - 2, which is the reference step: Next
     * there ran the preview checks instead of moving on, and the signature step
     * was never reachable. The preview checks then demanded a signature the
     * applicant had had no chance to give, and refused - so Next did nothing.
     */
    if (this.formPagination === this.formData.length - 1) {
      this.goToPreview();
      return;
    }
    if (this.payLoadData.isEligibility) {
      if (this.formPagination == 5) {
        this.payLoadData.certificationSignature.submissionDate =
          moment().format("MM-DD-YYYY");
        if (this.payLoadData.certificationSignature.isSignature) {
          this.signatureInvalid = false;
        } else {
          this.checkValidForm = true;
          this.signatureInvalid = true;
          setTimeout(() => {
            const el = document.getElementsByClassName("is-invalid")[0];
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "end" });
            }
          }, 100);
          return;
        }
      }

      this.$validator.validate().then(async (validate) => {
        if (this.formName === "certificationPartTwoRefererenceInformation") {
          this.referenceEmailDuplicateIndexs = utils.duplicateValueIdx(
            this.payLoadData,
            this.formName,
            true,
            "referenceEmailAddress"
          );
        }
        if (this.formName === "certificationPartTwoSupervisorInformation") {
          this.supervisorEmailDuplicateIndexs = utils.duplicateValueIdx(
            this.payLoadData,
            this.formName,
            true,
            "supervisorEmail"
          );
        }

        /*
         * validSOA belongs to Certification Details - it is emitted by the
         * scope-of-activity control that lives on that step. It was required
         * on every step, and only previousButton and navigateTab ever set it
         * back to true, so a false left behind there blocked Next for the
         * rest of the form: the later steps do not render that control, so
         * nothing could set it true again and nothing said why. Next simply
         * stopped working, with no message and nothing to scroll to.
         *
         * Check it on the step that owns it.
         */
        const isScopeOfActivityStep = this.formName === "certificationDetails";
        if (
          this.referenceEmailDuplicateIndexs.length === 0 &&
          this.supervisorEmailDuplicateIndexs.length === 0 &&
          validate &&
          (!isScopeOfActivityStep || this.validSOA)
        ) {
          if (this.formPagination === 3) {
            const supervisorEmailValidate =
              this.payLoadData.certificationPartTwoSupervisorInformation.filter(
                (supervisor: any) => {
                  if (
                    supervisor.supervisorEmail.toLowerCase() ===
                    this.payLoadData.certificationPartTwoApplicationForm.email.toLowerCase()
                  ) {
                    return supervisor;
                  }
                }
              );
            if (supervisorEmailValidate.length) {
              this.errorMessage =
                "Supervisor email id and applicant email id must be different *";
              return;
            }
          }

          if (this.formPagination === 4) {
            const duplicateEmail =
              this.payLoadData.certificationPartTwoRefererenceInformation.filter(
                (reference: any) => {
                  if (
                    reference.referenceEmailAddress.toLowerCase() ===
                    this.payLoadData.certificationPartTwoApplicationForm.email.toLowerCase()
                  ) {
                    return reference;
                  }
                }
              );
            if (duplicateEmail.length) {
              this.errorMessage =
                "Applicant email id and reference email id must be different *";
              return;
            }
            const supervisorEmails =
              this.payLoadData.certificationPartTwoSupervisorInformation.map(
                (supervisor: any) => {
                  return supervisor.supervisorEmail.toLowerCase();
                }
              );
            const supervisorReferenceDuplicateEmail =
              this.payLoadData.certificationPartTwoRefererenceInformation.filter(
                (reference: any) => {
                  if (
                    supervisorEmails.includes(
                      reference.referenceEmailAddress.toLowerCase()
                    )
                  ) {
                    return reference;
                  }
                }
              );
            if (supervisorReferenceDuplicateEmail.length) {
              this.errorMessage =
                "Supervisor email id and reference email id must be different *";
              return;
            }
          }

          // The step being completed NOW. nextPaginationUpdate() below moves
          // formPagination on, and isEdit rewrites it outright, so reading it
          // afterwards marks the step the applicant just arrived at instead of
          // the one they finished - leaving the finished tab grey.
          const completedStep = this.formPagination;
          this.isLoading = true;
          this.isValid = true;
          this.checkValidForm = false;
          if (this.formPagination < this.formData.length) {
            this.isNavLoad = true;
            // An autosave may be pending or in flight. Drop the pending one
            // and wait for the running one, so this updates the row the
            // autosave created instead of creating a second application.
            if (this.draftAutoSaveTimer) {
              clearTimeout(this.draftAutoSaveTimer);
              this.draftAutoSaveTimer = null;
            }
            await this.waitForDraftSave();
            if (!this.payLoadData.id) {
              await certificationFormApi
                .CertificationApplicationForm(
                  this.payLoadData.fillStatus,
                  this.payLoadData
                )
                .then((result: any) => {
                  this.isLoading = false;
                  this.certificateApplicantId = result.headers.location;
                  localStorage.setItem(
                    "certificateApplicationId",
                    this.certificateApplicantId
                  );
                  this.payLoadData.id = localStorage.getItem(
                    "certificateApplicationId"
                  );
                  localStorage.setItem(
                    "certificationFormPayload",
                    JSON.stringify(this.payLoadData)
                  );
                  if (!this.isEdit) {
                    this.nextPaginationUpdate();
                  }
                  const el = document.getElementById(this.mainId);
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }
                })
                .catch((error) => {
                  this.errorMessage = utils.errorMessage(error);
                  this.isLoading = false;
                });
            } else {
              this.payLoadData.id = localStorage.getItem(
                "certificateApplicationId"
              )
                ? localStorage.getItem("certificateApplicationId")
                : this.payLoadData.id;
              localStorage.setItem(
                "certificationFormPayload",
                JSON.stringify(this.payLoadData)
              );
              const id = this.payLoadData.id;
              await certificationFormApi
                .updateCertificationForm(this.payLoadData, id)
                .then((data) => {
                  this.isLoading = false;
                  if (!this.isEdit) {
                    this.nextPaginationUpdate();
                  }
                  const el = document.getElementById(this.mainId);
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }
                })
                .catch((error) => {
                  this.errorMessage = utils.errorMessage(error);
                  this.isLoading = false;
                });
            }
            if (this.isEdit) {
              this.formPagination = 6;
              this.formName = "certificationPartTwoApplicationForm";
            }
            if (!this.formCompletedIndex.includes(completedStep)) {
              this.formCompletedIndex.push(completedStep);
            }
            this.currentForm = this.payLoadData[this.formName];
            localStorage.setItem(
              "certificationFormFilledIndex",
              this.formCompletedIndex.toString()
            );
          }
        } else {
          setTimeout(() => {
            const el = document.getElementsByClassName("is-invalid")[0];
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "end" });
            }
          }, 50);
        }
      });
    }
  }

  public async goToPreview() {
    // The preview sits one past the last form step; see nextButton above.
    const previewIndex = this.formData.length;
    const slugs = [
      "",
      "certificationPartTwoApplicationForm",
      "certificationDetails",
      "certificationPartTwoSupervisorInformation",
      "certificationPartTwoRefererenceInformation",
      "certificationSignature",
    ];
    this.checkValidForm = true;
    for (let i = 0; i < previewIndex; i++) {
      if (slugs[i]) {
        this.formName = slugs[i];
      }
      this.formPagination = i;
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 60));
      // Step 0 is the eligibility acceptance, not a validated form.
      if (i === 0) {
        if (!this.payLoadData.isEligibility) {
          this.scrollToFirstInvalid();
          return;
        }
        continue;
      }
      if (i === previewIndex - 1) {
        this.payLoadData.certificationSignature.submissionDate =
          moment().format("MM-DD-YYYY");
        if (!this.payLoadData.certificationSignature.isSignature) {
          this.signatureInvalid = true;
          this.scrollToFirstInvalid();
          return;
        }
        this.signatureInvalid = false;
      }
      const valid = await this.$validator.validateAll();
      if (!valid) {
        this.scrollToFirstInvalid();
        return;
      }
      /*
       * Record the step as done. Next does this for the step it leaves, but
       * reaching the preview walks several steps at once - without this they
       * stayed grey in the tab bar, as though the applicant had skipped what
       * they had in fact just passed.
       */
      if (!this.formCompletedIndex.includes(i)) {
        this.formCompletedIndex.push(i);
      }
    }
    localStorage.setItem(
      "certificationFormFilledIndex",
      this.formCompletedIndex.toString()
    );
    this.persistDraft();
    this.formPagination = previewIndex;
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  private scrollToFirstInvalid() {
    setTimeout(() => {
      const el = document.getElementsByClassName("is-invalid")[0];
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 10);
  }

  public nextPaginationUpdate() {
    const page = this.formPagination + 1;
    if (page == 1) {
      this.formName = "certificationPartTwoApplicationForm";
    } else if (page == 2) {
      this.formName = "certificationDetails";
    } else if (page == 3) {
      this.formName = "certificationPartTwoSupervisorInformation";
    } else if (page == 4) {
      this.formName = "certificationPartTwoRefererenceInformation";
    } else if (page == 5) {
      this.formName = "certificationSignature";
    }
    this.formPagination = page;
  }

  public saveDraft() {
    // Save Draft is a deliberate save, so it reaches the server too - the
    // button says draft saved, and until now it only ever wrote this browser.
    this.persistDraft();
    this.$bvToast.show("example-toast");
    this.isValid = true;
    localStorage.setItem(
      "certificationFormPayload",
      JSON.stringify(this.payLoadData)
    );
    this.saveDataDraft = true;

    setTimeout(() => {
      this.saveDataDraft = false;
    }, 1000);
  }

  public previousButton() {
    this.isEdit = false;
    this.validSOA = true;
    this.referenceEmailDuplicateIndexs = [];
    this.supervisorEmailDuplicateIndexs = [];
    if (this.formPagination !== 0) {
      const el = document.getElementById(this.mainId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
      this.formPagination = this.formPagination - 1;
      if (this.formPagination == 1) {
        this.formName = "certificationPartTwoApplicationForm";
      } else if (this.formPagination == 2) {
        this.formName = "certificationDetails";
      } else if (this.formPagination == 3) {
        this.formName = "certificationPartTwoSupervisorInformation";
      } else if (this.formPagination == 4) {
        this.formName = "certificationPartTwoRefererenceInformation";
      } else if (this.formPagination == 5) {
        this.formName = "certificationSignature";
      }
    }
  }

  public onSubmit() {
    this.$validator.validate().then((validate) => {
      if (validate) {
        this.payLoadData.certificationSignature.submissionDate =
          moment().format("MM-DD-YYYY");
        let payloadStorage: any = localStorage.getItem(
          "certificationFormPayload"
        );
        if (payloadStorage) {
          payloadStorage = JSON.parse(payloadStorage);
          this.payLoadData = { ...payloadStorage };
        }
        this.isLoading = true;
        this.stopDraftAutoSave();
        this.payLoadData.fillStatus = "COMPLETED";
        this.payLoadData.id = localStorage.getItem("certificateApplicationId")
          ? localStorage.getItem("certificateApplicationId")
          : this.payLoadData.id;
        const id = this.payLoadData.id;
        certificationFormApi
          .updateCertificationForm(this.payLoadData, id)
          .then(() => {
            certificationFormApi
              .getCertificationApplicationForm(id)
              .then((result: any) => {
                const applicationCode = result.data.code;
                const someData = {
                  title: "Certified Young Adult Peer Support Specialist",
                  SubTitle: "Certification: Part Two",
                };
                this.$router.push({
                  path: "/form/submitted",
                  query: {
                    subTitle: someData.SubTitle,
                    applicationId: applicationCode,
                  },
                });
                this.isLoading = false;
              })
              .catch((error) => {
                this.errorMessage = utils.errorMessage(error);
                this.isLoading = false;
              });
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
            localStorage.removeItem("certificationFormPayload");
            localStorage.removeItem("certificateApplicationId");
            localStorage.removeItem("certificationFormFilledIndex");
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
          });
      }
    });
  }

  public eligibilityChecked(event: any) {
    this.payLoadData.isEligibility = event[0];
    this.isEligibility = true;
    this.formPagination = 1;
    if (!this.formCompletedIndex.includes(this.formPagination)) {
      this.formCompletedIndex.push(this.formPagination);
    }
    this.currentForm = this.payLoadData[this.formName];
    localStorage.setItem(
      "certificationFormFilledIndex",
      this.formCompletedIndex.toString()
    );
  }

  public closeToast() {
    this.$bvToast.hide("example-toast");
  }

  public numberValidation(evt: any, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public onlyAlphabets(evt: any, fieldName = "") {
    utils.onlyAlphabets(evt, fieldName);
  }

  public emptyEvent() {
    return;
  }

  public fieldValidation(
    value: any,
    eventName: string,
    fieldType: string,
    maxLength = 0,
    fieldName = ""
  ) {
    if (fieldType === "number") {
      this.eventBind[eventName](value, maxLength);
    } else if (fieldName === "state") {
      this.eventBind[eventName](value, fieldName);
    } else {
      this.eventBind[eventName](value);
    }
  }

  /**
   * Whether clicking a tab will actually go anywhere. Every tab is reachable
   * from the start now — the draft no longer has to exist first — so this is
   * only still here to keep the template's nav-locked class working.
   */
  public isTabNavigable(index: number): boolean {
    return true;
  }

  public navigateTab(slug: string, index: number) {
    if (index === this.formPagination) {
      return;
    }
    // Preview must be earned: opening it from the tab bar runs the same
    // step-by-step validation the Next button does, so a tab click cannot
    // skip a step that free navigation jumped over.
    //
    // The preview is the step past the last form one - length, not length - 1,
    // which is the signature. Keyed a step early, clicking Signature ran the
    // preview checks and landed on the preview instead of opening the
    // signature at all.
    if (index === this.formData.length) {
      this.goToPreview();
      return;
    }
    this.isEdit = false;
    this.referenceEmailDuplicateIndexs = [];
    this.supervisorEmailDuplicateIndexs = [];
    this.validSOA = true;
    this.persistDraft();
    this.formName = slug;
    this.formPagination = index;
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  // Draft saves are chained rather than fired in parallel: navigateTab does
  // not await this (the tab switches immediately), so jumping several tabs
  // quickly would otherwise leave overlapping PUTs racing, and whichever
  // response landed last would win regardless of the order they were sent.
  private draftSave: Promise<void> = Promise.resolve();

  /*
   * The local half on its own. Typing writes here and nowhere else: keystrokes
   * are not an instruction to save, and a request per field is both wasted and
   * a way for a half-typed value to be judged by the API before the applicant
   * has finished it. The server is written on the deliberate actions instead -
   * changing tab, Next, and Save Draft.
   */
  private saveDraftLocally() {
    localStorage.setItem(
      "certificationFormPayload",
      JSON.stringify(this.payLoadData)
    );
  }

  /*
   * The catch is what keeps this chain usable. Each save is appended to the
   * one before it, and Next awaits the chain before saving the step - so a
   * single rejected link leaves it permanently rejected, and every later
   * await throws inside an async handler with nowhere to report it. The
   * symptom is Next doing nothing at all, for the rest of the session.
   *
   * A draft save that fails is not worth stopping the applicant for: the
   * local copy holds their work and Next saves the step itself.
   */
  public persistDraft(): Promise<void> {
    this.draftSave = this.draftSave
      .then(() => this.saveDraftNow())
      .catch(() => undefined);
    return this.draftSave;
  }

  /*
   * Wait for an in-flight draft save, but not forever. Without a bound, a
   * request that never answers holds Next open indefinitely with the loader
   * showing and no way out. The wait only exists so Next updates the row the
   * autosave created rather than creating a second one; if it has not
   * finished by now, going ahead is better than stranding the applicant.
   */
  private waitForDraftSave(): Promise<void> {
    return Promise.race([
      this.draftSave,
      new Promise<void>((resolve) => setTimeout(resolve, 8000)),
    ]).then(() => undefined);
  }

  /**
   * Store the draft. The local copy is written unconditionally, so progress
   * survives a reload from the very first field the applicant fills.
   *
   * The server copy needs an email: fetchDetailsfromData() in the workflow API
   * keys the row on it (and rejects the save without a valid one), so the row is
   * created the moment a valid email exists and updated on every save after
   * that. Before then the draft is local-only, which is silent by design — the
   * applicant has not given us anything to file it under yet, so a failed save
   * is not something they can act on.
   */
  private async saveDraftNow() {
    localStorage.setItem(
      "certificationFormPayload",
      JSON.stringify(this.payLoadData)
    );
    const app = this.payLoadData.certificationPartTwoApplicationForm;
    if (!this.payLoadData.id) {
      if (!utils.canSaveDraftRemotely(app.email)) {
        return;
      }
      try {
        const result: any =
          await certificationFormApi.CertificationApplicationForm(
            this.payLoadData.fillStatus,
            this.payLoadData
          );
        const applicationId = result.headers.location;
        localStorage.setItem("certificateApplicationId", applicationId);
        this.payLoadData.id = applicationId;
        localStorage.setItem(
          "certificationFormPayload",
          JSON.stringify(this.payLoadData)
        );
      } catch (error) {
        // Kept quiet: an autosave the applicant did not ask for should not throw
        // a popup over the field they are typing in. The local copy above still
        // holds everything, and Next surfaces the real error when they submit.
      }
      return;
    }
    try {
      await certificationFormApi.updateCertificationForm(
        this.payLoadData,
        this.payLoadData.id
      );
    } catch (error) {
      this.errorMessage = utils.errorMessage(error);
    }
  }

  // Debounced autosave, armed once the form has finished loading so the CMS
  // render and the applicant prefill do not count as filling anything in. From
  // the first real keystroke every change is persisted.
  private draftAutoSaveTimer: any = null;

  private queueDraftSave() {
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
    }
    this.draftAutoSaveTimer = setTimeout(() => {
      this.draftAutoSaveTimer = null;
      this.saveDraftLocally();
    }, 1000);
  }

  private draftWatchStop: any = null;

  private startDraftAutoSave() {
    this.draftWatchStop = this.$watch(
      "payLoadData",
      () => {
        // Errors are raised by an action - Next, or the bounce to an
        // incomplete step - and dismissed the moment the applicant starts
        // answering them. Without this the gate stays open after a failed
        // Next and vee-validate re-runs on every keystroke, so typing an
        // email is marked invalid letter by letter until it happens to be
        // complete. They are shown again by the next Next.
        this.checkValidForm = false;
        this.queueDraftSave();
      },
      { deep: true }
    );
  }

  /*
   * Submitting ends the draft. The payload is still mutated on the way out -
   * fillStatus, the signature date, the id read back from storage - and each
   * of those fires the watcher above, queueing a local write. onSubmit then
   * clears the stored draft, and the queued write lands a second later and
   * puts it straight back, so the next application opens on the submitted
   * one's data. Stop the watcher and drop anything pending before the submit
   * runs, so no write can outlive it.
   */
  private stopDraftAutoSave() {
    if (this.draftWatchStop) {
      this.draftWatchStop();
      this.draftWatchStop = null;
    }
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
      this.draftAutoSaveTimer = null;
    }
  }

  public beforeDestroy() {
    this.stopDraftAutoSave();
  }

  public fieldUpdate(groupName = "", initial = false, supervisorIdx: number) {
    switch (groupName) {
      case "stillEmployed":
        if (
          this.payLoadData.certificationPartTwoSupervisorInformation[
            supervisorIdx
          ].stillEmployed === "No"
        ) {
          if (supervisorIdx !== undefined) {
            if (this.supervisorEndDateShowIdx.length) {
              this.supervisorEndDateShowIdx.push(supervisorIdx);
            } else {
              this.supervisorEndDateShowIdx = [supervisorIdx];
            }
            if (!this.supervisorStartDateShowIdx.includes(supervisorIdx)) {
              if (this.supervisorStartDateShowIdx.length) {
                this.supervisorStartDateShowIdx.push(supervisorIdx);
              } else {
                this.supervisorStartDateShowIdx = [supervisorIdx];
              }
            }
          }
          this.supervisorUIUpdate = utils.UIUpdateUsingKey(
            this.supervisorUIUpdate
          );
        } else {
          if (!this.supervisorStartDateShowIdx.includes(supervisorIdx)) {
            if (this.supervisorStartDateShowIdx.length) {
              this.supervisorStartDateShowIdx.push(supervisorIdx);
            } else {
              this.supervisorStartDateShowIdx = [supervisorIdx];
            }
          }
          const idx = this.supervisorEndDateShowIdx.findIndex(
            (element) => element === supervisorIdx
          );
          if (idx > -1) {
            this.supervisorEndDateShowIdx.splice(idx);
            this.payLoadData.certificationPartTwoSupervisorInformation[
              supervisorIdx
            ].endDate = "";
          }
          this.supervisorUIUpdate = utils.UIUpdateUsingKey(
            this.supervisorUIUpdate
          );
        }
        break;
      default:
        break;
    }
  }

  public addAnother() {
    this.payLoadData.certificationPartTwoSupervisorInformation.push({
      supervisorAgencyOrOrganization: "",
      supervisorPositionOrTitle: "",
      stillEmployed: "",
      startDate: "",
      endDate: "",
      supervisorFirstName: "",
      supervisorLastName: "",
      supervisorCredentials: "",
      supervisorPhone: "",
      supervisorEmail: "",
      descripePeerSupportResponsibity: "",
    });
    this.supervisorFormFields.push(this.tempSupervisorFormFields);
    this.supervisorUIUpdate = utils.UIUpdateUsingKey(this.supervisorUIUpdate);
  }

  public removeAddedSupervisor(indexForm: number) {
    this.payLoadData.certificationPartTwoSupervisorInformation.splice(
      indexForm,
      1
    );
    this.supervisorFormFields.splice(indexForm, 1);
    this.supervisorUIUpdate = utils.UIUpdateUsingKey(this.supervisorUIUpdate);
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }
  public goBack() {
    if (this.$route.query.isDraft) {
      localStorage.removeItem("certificationFormPayload");
      localStorage.removeItem("certificationFormFilledIndex");
    }
    this.$router.push({
      path: `/application`,
      query: {
        form: "certification",
      },
    });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("active");
      el.classList.remove("remove-container");
    }
  }
}
